import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthLoginGuard implements CanActivate {
constructor(private router:Router){

}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      let data = JSON.parse(localStorage.getItem("userProfile"))
      if(data){
       if(data.role == "vet"){
        this.router.navigate(['/vets']);

       }else{
        this.router.navigate(['/delivery']);

       }
       
      }else{

      return true;

      }

  }
  
}
